module.exports = __webpack_public_path__ + "fonts/MavenPro-Light-200.a5d96ea5.otf";